'use strict';

import { WebAPI } from '../API/WebAPI';

/**
 * Standard response for deleted entity
 */
export interface DeleteResponse {
  deleted: boolean;
}

export class CoreRepository {
  protected webAPI: WebAPI;

  public constructor() {
    this.webAPI = new WebAPI();
  }

  public setAccessToken(accessToken: string) {
    this.webAPI.setAccessToken(accessToken);
    return this;
  }
}
